import React from 'react';
import { connect } from 'react-redux';
import R from 'ramda';
import PropTypes from 'prop-types';
import { HeroFullOverlay } from '@cotyorg/ccx-organism-hero';
import Heading from '@cotyorg/ccx-atoms/Heading';
import { CardoList } from '@cotyorg/ccx-organism-cardo-list';
import SectionHeader from '../../atoms/SectionHeader';
import StandardLayout from '../../templates/StandardLayout';
import { tutorialsCardListBreakpointConfig } from './cardo.config';
import { isLargeBreakpoint } from '../../utils';

const TutorialsComponent = ({
  cardSection1Cards = [],
  sectionHeadings,
  currentBreakpoint,
}) => (
  <StandardLayout>
    <div className="tutorials-page">
      <div className="grid-container">
        <div className="grid-x grid-margin-x">
          <div className="cell">
            <div className="hero-absolute-image">
              <HeroFullOverlay
                heroStoreDataKey="hero1"
                isContentFirst={isLargeBreakpoint({ currentBreakpoint })}
              />
            </div>

            <SectionHeader>
              <Heading extraClass="section__title" level={2}>
                {R.path(['cardSection1Heading', 'heading'])(sectionHeadings)}
              </Heading>
              <Heading extraClass="section__sub-title" level={3}>
                {R.path(['cardSection1Heading', 'introduction'])(
                  sectionHeadings
                )}
              </Heading>
            </SectionHeader>

            <CardoList
              data={cardSection1Cards}
              contentTheme="alpha"
              breakpointConfig={tutorialsCardListBreakpointConfig}
              isTitleUnderlined={false}
              isSmallTitle
              headingLevel={5}
              tagHeadingLevel={6}
              initialNumberToShow={4}
              fixedHeight={false}
              showMoreIconSrc="/ccx-files/assets/plus-within-circle.svg"
            />
          </div>
        </div>
      </div>
    </div>
  </StandardLayout>
);

TutorialsComponent.propTypes = {
  cardSection1Cards: PropTypes.arrayOf(PropTypes.object),
  sectionHeadings: PropTypes.objectOf(PropTypes.object),
  currentBreakpoint: PropTypes.string,
};

export default connect(({ content, breakpoints }) => ({
  currentBreakpoint: R.prop('current', breakpoints),
  cardSection1Cards: R.path(['cardoGroup', 'cardSection1Cards'])(content),
  sectionHeadings: R.prop('sectionHeadings', content),
}))(TutorialsComponent);
